import "normalize.css";
import "./scss/style.scss";

import App from "./js/App.js";
window.onload = () => {
  // console.log("Hello World!");
  new App();
};

// console.log("Index js is working properly");